import angular from "angular";
import Assert from "tbAssert";

import ngResource from "angular-resource";
import OfficeFactoryModule from "../models/factories/OfficeFactory";
import TbAppConfigDataServiceModule from "../config/tb-app-config/TbAppConfigDataService";

import OfficeType from "../models/OfficeType";

function OfficeTypeDataServiceFactory($resource, OfficeFactory, TbAppConfigDataService) {

    Assert.StrictAssert(OfficeFactory != null, "Assertion Failure: Missing Office Factory Service Dependency");
    Assert.StrictAssert(TbAppConfigDataService != null, "Assertion Failure: Missing TrackerBase Application Configuration Data Service Dependency");

    const tbServerBaseUrl = TbAppConfigDataService.tbServerBaseUrl;

    const tbOfficeTypeDataApiUrl = tbServerBaseUrl + "/api/officetypes/:officeTypeId";
    const tbOfficeTypeDetailsDataApiUrl = tbServerBaseUrl + "/api/officetypes/:officeTypeId/details";
    const tbOfficeTypeDataApiParams = { officeTypeId: "@officeTypeId" };

    const tbOfficeTypeSubscribersApiUrl = tbServerBaseUrl + "/api/officetypes/:officeTypeId/subscribers/:recipientId";
    const tbOfficeTypeSubscribersApiParams = {officeTypeId: "@officeTypeId", recipientId: "@recipientId"};

    const officeTypeDataResponseInterceptor = (serverResponse) => {
        let serverOfficeTypeObj =
            OfficeType.FromServerOfficeType(
                serverResponse.data,
                OfficeFactory.FromServerOffice
            );

        angular.extend(serverResponse.resource, {
            result: serverOfficeTypeObj
        });

        return serverResponse.resource;
    };

    return $resource(
        tbOfficeTypeDetailsDataApiUrl,
        tbOfficeTypeDataApiParams,
        {
            get: {
                url: tbOfficeTypeDetailsDataApiUrl,
                method: "GET",
                isArray: false,
                responseType: "json",
                interceptor: {
                    response: officeTypeDataResponseInterceptor
                }
            },
            getCore: {
                url: tbOfficeTypeDataApiUrl,
                method: "GET",
                isArray: false,
                responseType: "json",
                interceptor: {
                    response: officeTypeDataResponseInterceptor
                }
            },
            addSubscription: {
                method: "PUT",
                url: tbOfficeTypeSubscribersApiUrl,
                params: tbOfficeTypeSubscribersApiParams ,
                isArray: false,
                responseType: "json",
                interceptor: {
                    response: officeTypeDataResponseInterceptor
                }
            },
            removeSubscription: {
                method: "DELETE",
                url: tbOfficeTypeSubscribersApiUrl,
                params: tbOfficeTypeSubscribersApiParams,
                isArray: false,
                responseType: "json",
                interceptor: {
                    response: officeTypeDataResponseInterceptor
                }
            }
        }
    );
}

OfficeTypeDataServiceFactory.$inject = [ "$resource", "OfficeFactory", "TbAppConfigDataService" ];

export default angular
    .module("trackerbase-app.services.office-type-data-service",[
        ngResource,
        OfficeFactoryModule,
        TbAppConfigDataServiceModule
    ])
    .factory("OfficeTypeData", OfficeTypeDataServiceFactory)
    .name;



//////////////////
// WEBPACK FOOTER
// ./src/services/OfficeTypeDataService.js
// module id = BopL
// module chunks = 1